import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'wk-restore-version',
  templateUrl: 'restore-version.dialog.html',
  styleUrls: ['./restore-version.dialog.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class RestoreVersionDialogComponent {
  sectionType = 1;
  documentName: string;
  versionId: string;
  constructor(
    public dialogRef: MatDialogRef<RestoreVersionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.documentName = data.name;
    this.versionId = data.id;
  }
  closeDialog(): void {
    this.dialogRef.close();
  }

  saveVersion() {
    const isAMajorVersion = this.sectionType === 1 ? false : true;
    const data = {
      isMajorVersion: isAMajorVersion,
      comment: this.data.comment,
    };
    this.dialogRef.close(data);
  }
}
